interface Dateable {
    creationDate: string;
}

export interface DateGroup<T> {
    label: string;
    items: T[];
}

function getDateGroupLabel(isoDate: string): string {
    const eventDate = new Date(isoDate);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (a: Date, b: Date) =>
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();

    if (isSameDay(eventDate, today)) return 'Today';
    if (isSameDay(eventDate, yesterday)) return 'Yesterday';

    return eventDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
}

export function groupByDate<T extends Dateable>(items: T[]): DateGroup<T>[] {
    const groups: DateGroup<T>[] = [];
    let currentLabel = '';

    for (const item of items) {
        const label = getDateGroupLabel(item.creationDate);
        if (label !== currentLabel) {
            groups.push({ label, items: [item] });
            currentLabel = label;
        } else {
            groups[groups.length - 1].items.push(item);
        }
    }

    return groups;
}
